import Post from './Post';
class InvestorFeed {
    count;
    pagination;
    items;
    constructor(data) {
        this.count = data.count;
        this.pagination = data.pagination;
        this.items = data.items.map(item => new Post(item));
    }
}
export default InvestorFeed;
